import { component$ } from "@builder.io/qwik";
import { ScoreBadge } from "./score-badge";
import { Feature, hasFeature } from "~/lib/has-feature";
import type { MembershipPlan } from "~/lib/schemas";
import { CDNImage } from "./cdn-image";

export const CoachProfileImage = component$<{
  coach: { membershipPlan: MembershipPlan };
  profilePictureUrl?: string | null;
  fullName: string;
  score?: number | null;
}>(({ coach, profilePictureUrl, fullName, score }) => {
  const imgClass = [
    "mx-auto aspect-square rounded-full object-cover",
    {
      "animate-bg-gradient border-gradient-pro-purple border-4": hasFeature(
        coach,
        Feature.FancyProfile,
      ),
    },
  ];

  return (
    <div class="relative">
      {profilePictureUrl ? (
        <CDNImage
          src={profilePictureUrl}
          alt={fullName}
          width={200}
          height={200}
          class={imgClass}
        />
      ) : (
        <div class={[...imgClass, "bg-gray-400/20"]} />
      )}
      {score && <ScoreBadge score={score} />}
    </div>
  );
});
